import Image from '../../../components/global/image/BaseImage';
import * as Boxes from '../../../components/styles/blocks';
import * as vars from '../../../components/styles/variables';
import pSBC from 'shade-blend-color';
import styled from 'styled-components';
import Text from '../../../components/global/text/Paragraph';
import Icon from '../../../components/global/BrandIcon';
import flowPlaceholder from '../../../public/placeholders/pirate-2d-not-claimed.jpg';
import { Tooltip } from 'antd';
import Pirate from '../../../services/presenters/Pirate';
import Paragraph from '../../../components/global/text/Paragraph';

const imgsPlaceholders = {
  ethImgUrl: '',
  flowImgUrl: flowPlaceholder.src,
}

const blockchainIcon = {
  eth: 'eth',
  flow: 'flow',
}

const CardText = styled(Text)`
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  font-weight: 400;
  color: inherit;
  ${({ fontSize }) => fontSize && `font-size: ${fontSize};`}
`

const Card = styled(Boxes.Block)`
  position: relative;
  color: ${pSBC(-0.25, vars.colorPallet.piratePink)};
  padding-right: 10px;
  padding-bottom: 10px;

  .card-content{
    cursor: pointer;
    padding: 10px;
    border-radius: 10px;
    border: 2px solid ${pSBC(-0.5, vars.colorPallet.piratePink)};
    background-color: ${vars.colorPallet.pageBg};
    position: relative;
    z-index: 2;
  }

  .card-price-tag{
    padding: 2px 5px;
  }

  &:after{
    content: "";
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    position: absolute;
    top: 10px;
    left: 10px;
    border-radius: 10px;
    border: 2px solid ${pSBC(-0.5, vars.colorPallet.piratePink)};
    z-index: 0;
  }

  &:hover{
    color: ${vars.colorPallet.piratePink};
    
    &:after{
      background-color: ${vars.colorPallet.greenUp};
    }
    .card-price-tag{
      background-color: ${vars.colorPallet.piratePink};
      color: ${vars.colorPallet.purple};
      border-radius: 10px;
    }
  }
`;

const SquareBox = styled(Boxes.Block)`
  position: relative;
  border-radius: 10px;
  overflow: hidden;

  .content{
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const MainCard = ({ pirate, blockchain, onClick }) => {
    
  const { attributes: pirateAttrs } = pirate;
  const { tokenId } = pirateAttrs;

  const pirateImg = (() => {
    if(blockchain === 'flow' && !global.claimEnabled)
      return imgsPlaceholders[`${blockchain}ImgUrl`];

    if (pirateAttrs[`${blockchain}Claimed`]) 
      return pirateAttrs[`${blockchain}ImgUrl`];

    return imgsPlaceholders[`${blockchain}ImgUrl`];
  })();
  
  const presenter = new Pirate(pirate.attributes);
  const pirateName = presenter.customName(blockchain);
  const piratePrice = presenter.formattedPrice(blockchain);
  const rank = presenter.getRanking();

  return (
    <Card claimed>
      <div className="card-content" onClick={() => onClick(pirate)}>
        <SquareBox cursor="pointer" bRadius="10px" paddingT="100%">
          <div className="content">
            <Image src={pirateImg} width="100%" bRadius="10px"/>
          </div>
        </SquareBox>
        <Boxes.Flex ai="center" jc="space-between" paddingL="10px" marginT="10px">
          <Tooltip 
            placement="topLeft" 
            title={pirateName ? `${pirateName} #${tokenId}` : null}
          >
              <CardText as="h6" fontSize={vars.fontSizes.small }>
                <Boxes.Flex wrap="nowrap">
                  {`#${tokenId}`}
                  {!!rank && (
                    <Paragraph color={vars.colorPallet.piratePurple} marginL="4px" fontSize="12px" >
                      / RANK {rank}
                    </Paragraph>
                  )}
                </Boxes.Flex>
                <div>{pirateName}</div>
              </CardText>
          </Tooltip>
          <Boxes.Flex className="card-price-tag" ai="center">
            <Icon name={blockchainIcon[blockchain]} marginR="2px" fontSize={vars.fontSizes.tagline}/>
            {!!piratePrice && blockchain !== 'flow' && (
              <CardText as="h6" fontSize={vars.fontSizes.small}>
                {piratePrice}
              </CardText>
            )}
          </Boxes.Flex>
        </Boxes.Flex>
      </div>
    </Card>
  )
}

export default MainCard
